// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/static/" + chunkId + "." + "e8bf391c42b1a61bbbe32f16a8c2d09cdb0e24426b5e47f4f9b098e92c24f52a" + ".css";
};